import React, { useContext, useState } from "react";

import legajoContext from "../../context/legajoContext/legajoContex";
import ProveedoresList from "../../components/proveedoresList/ProveedoresList";
import SearchInput from "../../components/searchInput/SearchInput";

import Swal from 'sweetalert2'

import './Proveedor.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { Navigate, useNavigate } from "react-router-dom";
import AbmProveedores from "../../components/abmProveedores/abmProveedores";
import authContext from "../../context/authentication/authContex";
import proveedorContext from "../../context/proveedoresContext/proveedorContext";

const Proveedor = () =>{

  const { usuario, hasWebServiceConfigured } = useContext(authContext);

  const [filter,setFilter] = useState('');
  const [showAbm, setShowAbm] = useState(false);
  const {proveedoresList, actualizarProveedoresList, actualizarProveedoresFromSoftland} = useContext(proveedorContext);
  const [proveedorToEdit, setProveedorToEdit] = useState({});
  const navigate = useNavigate();

  const handleGetProveedoresFromSoftland = async() => {
    if(hasWebServiceConfigured){
      Swal.fire({
        title: 'Desea actualizar la lista?',
        html: `Se traeran los datos de Softland para sobreescribir la base de datos de la aplicación.`,
        showCancelButton: true,
        confirmButtonText: 'Actualizar',
        cancelButtonText: 'No, cancelar',
        showLoaderOnConfirm: true,
        preConfirm: async () => {
            return await actualizarProveedoresFromSoftland()
            .then(response => {
              if (!response.status) {
                throw new Error(response.msg)
              }
              return response;
            })
            .catch(error => {
              Swal.showValidationMessage(
                `Request failed: ${error}`
              )
            })
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
            Swal.fire(
                'Actualizado!',
                'La base de datos ha sido actualizada correctamente.',
                'success'
            );
            //actualizarProveedoresList();
        }
      })
    }else{
      Swal.fire({
        title:"No es posible actualizar los Proveedores!", 
        text:"No se ha configurado una conexión con un sistema externo, utilice el botón + en azul para dar de alta los proveedores en forma manual o mediante una planilla xlsx. Si desea configurar un sistema externo comuníquese con el soporte de XertuX",
        confirmButtonColor:'#3d4d87',
      });
    }
  }

  const handleEditProveedor = (proveedor) =>{
    setProveedorToEdit(proveedor);
    setShowAbm(true);
  }

  return <div className="legajoDiv">
      <button style={{cursor:'pointer'}} onClick={()=>navigate('/abms')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
      <SearchInput filter={filter} buscar={setFilter}/>
      <button className="agregar-productos-btn" onClick={()=>setShowAbm(true)}> + </button>
      <button className="getProveedoresFromSoftlandBtn" onClick={handleGetProveedoresFromSoftland}>Actualizar Proveedores</button>
      {(proveedoresList == undefined) ? <h3 className="warningStatusMsg">Cargando<span>.</span><span>.</span><span>.</span></h3> : (proveedoresList.length == 0) ? <h3 className="warningStatusMsg">No hay proveedores cargados</h3> : <ProveedoresList proveedoresList={proveedoresList} filter={filter} handleEditProveedor={handleEditProveedor}/>}
      {showAbm && <AbmProveedores setShowAbm={setShowAbm} proveedorToEdit={proveedorToEdit} setProveedorToEdit={setProveedorToEdit}/>}
  </div>
}

export default Proveedor;